// 현재 디렉토리(`.`)에서 .js 파일을 가져오기 위한 require.context 생성
// 두 번째 인자 false → 하위 디렉토리 탐색 안 함
// 세 번째 인자 /\.js$/ → .js 파일만 매칭
const files = require.context('.', false, /\.js$/)

// modules 객체 초기화
const modules = {}

// 가져온 파일 목록 순회
files.keys().forEach((key) => {
  // index.js 파일은 제외 (자기 자신 불러오기 방지)
  if (key === './index.js') return

  // 예: './user.js' → 'user'
  // 파일명을 소문자로 변환하고 './'와 '.js' 제거
  const moduleName = key.toLowerCase().replace(/(\.\/|\.js)/g, '')

  // 해당 모듈을 import 해서 modules 객체에 할당
  modules[moduleName] = files(key).default
})

// 모든 모듈을 export
export default modules
